export enum ButtonTheme {
  LIGHT = "light",
  LIGHT_DESTRUCTIVE = "light-destructive",
  DARK = "dark",
  DARK_DESTRUCTIVE = "dark-destructive"
}

export enum TertiaryButtonTheme {
  LIGHT = "light",
  LIGHT_DESTRUCTIVE = "light-destructive",
  DARK = "dark",
  DARK_DESTRUCTIVE = "dark-destructive",
  GREY = "grey"
}

export enum ButtonSize {
  DEFAULT = "default",
  SMALL = "small"
}
